import React from 'react';

const Nodata = () => {
    return (
        <div>
            <h1 className='text-center font-bold text-red-500 py-5'>404 Page Not Found!</h1>
        </div>
    );
};

export default Nodata;